import React, { useEffect, useState } from 'react';
import { useInView } from "react-intersection-observer";
import { Skeleton } from 'antd';
import axios from 'axios';
import config from '../../../settings/config.json';

import Logo from '../../../assets/img/whitelogo.jpg';

function Home_About() {
  const [bestMessage, setBestMessage] = useState(null);
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`/api/settings`);
        setSettings(response.data[0]);
      } catch (error) {
        console.error('ERROR:', error);
      }
    };

    fetchSettings();
    
    const interval = setInterval(fetchSettings, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await axios.get(`/api/messages/bestMsg`);
        setBestMessage(response.data);
      } catch (error) {
        console.error('ERROR:', error);
      }
    };

    fetchMessages();
    
    const interval = setInterval(fetchMessages, 5000);
    return () => clearInterval(interval);
  }, []);

  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <div className='About'>

      <div className='qw-pc'>
      <br /><br /><br /><br /><br /><br id='about' /><br /><br /><br />
      <center><h1 className={`text-secondary ${inView ? "view" : "none"}`} ref={ref}>{settings?.client?.homePage?.aboutUs?.title ? settings?.client?.homePage?.aboutUs?.title : <Skeleton.Button active />}</h1></center>
      <br />
      <div className={`center-content ${inView ? "view" : "none"}`}>
        <img src={Logo} width="300px" className='ggh' />
        <div className='about p-5'>
          <span className='custom-font'>{settings?.client?.homePage?.aboutUs?.content ? settings?.client?.homePage?.aboutUs?.content : <Skeleton active />}</span>
        </div>
      </div>
      </div>

      <div className='qw-mobile'>
      <br /><br /><br /><br />
      <center><h1 className={`text-secondary`} id='about2'>{settings?.client?.homePage?.aboutUs?.title ? settings?.client?.homePage?.aboutUs?.title : <Skeleton.Button active />}</h1></center>
      <center>
      <p className='custom-font p-5'>{settings?.client?.homePage?.aboutUs?.content ? settings?.client?.homePage?.aboutUs?.content : <Skeleton active />}</p>
      </center>
      </div>

    </div>
  );
}

export default Home_About;